const defaultSettings = {
  name: "Transform",
  icon: 'mdi-sitemap',
  showLabel: true,
  size: {
    width: 'auto',
    height: 60
  },
  resizable: false,
  draggable: true,
  has: {
    in: true,
    out: true,
    settings: true
  },
  inColor: "#9C27B0", // Purple for transform operations
  outColor: "#9C27B0",
  layout: "horizontal",
  components: [/Workflow_.*/],
  openPropertyEditorByClick: true,
  settings: {
    locked: false,
    order: 0,
    operations: [],
    validateOutput: true,
    schema: {} // Optional JSON schema for output validation
  }
};

export default defaultSettings; 